module.exports = __webpack_public_path__ + "static/media/mirchi4.0043cc7b.png";